import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const UPDATE_GLOBAL_LLM_CONFIGURATION = 'UPDATE_GLOBAL_LLM_CONFIGURATION';
export const UPDATE_GLOBAL_LLM_CONFIGURATION_SUCCESS = 'UPDATE_GLOBAL_LLM_CONFIGURATION_SUCCESS';
export const UPDATE_GLOBAL_LLM_CONFIGURATION_FAIL = 'UPDATE_GLOBAL_LLM_CONFIGURATION_FAIL';
export const UPDATE_GLOBAL_LLM_CONFIGURATION_RESET = 'UPDATE_GLOBAL_LLM_CONFIGURATION_RESET';

export const updateGlobalLLMConfiguration = (params) => {
	return {
		type: UPDATE_GLOBAL_LLM_CONFIGURATION,
		params,
	};
};

export const updateGlobalLLMConfigurationSuccess = (response) => {
	return {
		type: UPDATE_GLOBAL_LLM_CONFIGURATION_SUCCESS,
		response,
	};
};

export const updateGlobalLLMConfigurationFail = (response) => {
	return {
		type: UPDATE_GLOBAL_LLM_CONFIGURATION_FAIL,
		response,
	};
};

export const updateGlobalLLMConfigurationReset = () => {
	return {
		type: UPDATE_GLOBAL_LLM_CONFIGURATION_RESET,
	};
};

export const updateGlobalLLMConfigurationApi = (data) => {
	return (dispatch) => {
		dispatch(updateGlobalLLMConfiguration());
		axios
			.post(`${config.api.base_url}/global-llm-configuration`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const updateGlobalLLMConfigurationData = response.data;
				dispatch(updateGlobalLLMConfigurationSuccess(updateGlobalLLMConfigurationData));
			})
			.catch((error) => {
				const errorMsg = error.response?.data?.message || error.message;
				dispatch(updateGlobalLLMConfigurationFail({ message: errorMsg }));
			});
	};
};

